import { AccUpgradeState } from './index';
import { IStore } from '@store/index';
import { GetterTree } from 'vuex';
import { NL_NL } from "@constants/locale";

export default {
    getAvailableAccUpgrades(state: AccUpgradeState){
        return state.availableAccommodationUpgrades.days;
    },

    getAccUpgrades(state: AccUpgradeState){
        return state.accommodationUpgrades;
    },

    isAccUpgradePreselected: (state: AccUpgradeState) => (currentId: string | number): boolean => {
        return Object.values(state.accommodationUpgrades ?? {}).some(upgrade => upgrade?.id === currentId);
    },

    getLocalizedAccContent: (state, getters, rootState) => (content: string|null): string|null => {
        if (content !== null && rootState.checkout.checkoutSettings.locale === NL_NL) {
            return content.toLowerCase();
        }

        return content;
    }
} as GetterTree<AccUpgradeState, IStore>
